import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "../common/constants";
import { useAuth } from "../contexts/AuthContext";
import { Loader } from "../ui/Loader";

// Waits for the boot silent-refresh to settle (loading) before deciding, so a
// page reload doesn't bounce an authenticated user to /login. adminOnly gates
// user management + change history.
export function ProtectedRoute({ children, adminOnly }: { children: ReactNode; adminOnly?: boolean }) {
  const { isLoggedIn, loading, admin } = useAuth();

  if (loading) return <Loader screen label="Loading your workspace…" />;
  if (!isLoggedIn) return <Navigate to={ROUTES.LOGIN} replace />;
  if (adminOnly && admin?.role !== "admin") return <Navigate to={ROUTES.PAGES} replace />;
  return <>{children}</>;
}
